import { createTrpcClient } from "@repo/api/client";
import { env } from "@/env";

// Use absolute path when same-origin to avoid relative URL issues on nested routes
const serverUrl = env.PUBLIC_SERVER_URL || "/";
export const trpcClient = createTrpcClient({
  serverUrl
});